import React from 'react'
import PropTypes from 'prop-types'
import Typography from '@material-ui/core/Typography'
import withStyles from '@material-ui/core/styles/withStyles'
import { RootMeta } from 'components/Meta'

const styles = (theme) => ({
  root: {
    padding: 50,
    [theme.breakpoints.down('sm')]: {
      padding: 10,
    },
  },
  content: {
    width: 900,
    margin: 'auto',
    [theme.breakpoints.down('sm')]: {
      width: '90%',
    },
  },
})

const PrivacyPolicyPage = ({ classes, data }) => {
  const {
    page,
    site: { siteMetadata },
  } = data
  return (
    <div className={classes.root}>
      <RootMeta
        url={siteMetadata.siteUrl + '/privacy-policy'}
        title={`Privacy Policy | ${siteMetadata.siteName}`}
      />
      <div className={classes.content}>
        <Typography
          align="center"
          variant="headline"
          style={{ fontWeight: 500 }}
          gutterBottom
          paragraph
        >
          PRIVACY POLICY
        </Typography>
        <Typography dangerouslySetInnerHTML={{ __html: page.html }} />
      </div>
    </div>
  )
}

PrivacyPolicyPage.propTypes = {
  classes: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
}

// prettier-ignore
// eslint-disable-next-line
export const query = graphql`
  query PrivacyPolicyPageQuery {
    site {
      siteMetadata {
        siteUrl
        siteName
        siteDescription
      }
    }
    page: markdownRemark(fields: { slug: { regex: "/\/privacy-policy/" } }) {
      html
      timeToRead
      frontmatter {
        title
      }
    }
  }
`

export default withStyles(styles)(PrivacyPolicyPage)



// WEBPACK FOOTER //
// ./src/pages/privacy-policy.js